import { Grid } from '@mui/material';
import config from 'config';
import { MY } from 'config/fe-routes';
import IconChat from 'public/icons/icn-chat-social.svg';
import IconFacebook from 'public/icons/icn-facebook.svg';
import IconLink from 'public/icons/icn-link.svg';
import React, { Fragment, useEffect, useState } from 'react';
import { FacebookProvider, Share } from 'react-facebook';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { openLoginModal } from 'store/actions/login.actions';
import { UserType } from 'types/user.types';
import { copyToClipboard } from 'utils/dom-element-helpers';
import { redirectTo } from 'utils/route-helpers';
import { useNotification } from 'utils/snackbar';

import { LikeButton } from '../buttons/LikeButton';

type ToolbarProps = {
  isLiked: boolean;
  hideLike?: boolean;
  hideMessage?: boolean;
  likeCallback?: () => void;
  shopSlug: string;
  productSlug?: string;
  user: UserType;
};

const mapStateToProps = ({ userData }) => ({
  user: userData && userData.user,
});

const SocialToolbar = (props: ToolbarProps) => {
  const { isLiked, likeCallback, hideLike, shopSlug, productSlug, hideMessage, user } = props;
  const { t } = useTranslation();
  const { showSuccessNotification } = useNotification();
  const isLoggedIn = user?.isLoggedIn;

  const [shareUrl, setShareUrl] = useState('');

  useEffect(() => {
    setShareUrl(window.location.href);
  });

  const redirectToConversation = () => {
    if (productSlug) {
      return redirectTo({
        ...MY.CONVERSATION_WITH_PRODUCT(shopSlug, productSlug),
      });
    }

    return redirectTo({ ...MY.CONVERSATION(shopSlug) });
  };

  return (
    <Grid container className="social-toolbar" alignItems="center">
      {[
        !hideLike && (
          <LikeButton liked={isLiked} onClick={likeCallback} label={t('common.like')} classes="social-toolbar-btn like-btn" large />
        ),

        <FacebookProvider appId={config.facebook.appId} key="toolbar-fb">
          <Share href={shareUrl}>
            {({ handleClick }) => (
              <div
                className="social-toolbar-btn share-btn"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  // Require login
                  if (!isLoggedIn) {
                    openLoginModal(true);

                    return;
                  }
                  handleClick(e);
                }}
              >
                <IconFacebook />
                <p>{t('common.share')}</p>
              </div>
            )}
          </Share>
        </FacebookProvider>,

        <div
          className="social-toolbar-btn copy-btn"
          key="toolbar-copy"
          role="button"
          tabIndex={0}
          onClick={() => {
            copyToClipboard(window.location.href);
            showSuccessNotification(t('common.link-copied'), {
              preventDuplicate: true,
            });
          }}
        >
          <IconLink />
          <p>{t('common.copy-link')}</p>
        </div>,

        !hideMessage && (
          <div
            className="social-toolbar-btn message-btn"
            onClick={() => {
              // Require login
              if (!isLoggedIn) {
                openLoginModal(true);

                return;
              }
              redirectToConversation();
            }}
            role="link"
            aria-hidden="true"
          >
            <IconChat />
            <p>{t('common.send-message')}</p>
          </div>
        ),
      ]
        .filter((item) => !!item)
        .map((item, itemIndex) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={'social-toolbar-item-' + itemIndex}>
            <Grid className="social-toolbar-item">{item}</Grid>
          </Fragment>
        ))}
    </Grid>
  );
};

export default connect(mapStateToProps)(SocialToolbar);
